import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.background};
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const GamesContainer = styled.div`
  padding: 12px;
  flex: 1;
  position: relative;

  > button {
    background: ${({ theme }) => theme.green};
    font-size: 1.5rem;

    color: ${({ theme }) => theme.white};

    padding: 8px 25px;

    position: absolute;
    top: 30px;
    right: 100px;

    transition: filter 0.2s;

    svg {
      display: none;
    }

    p {
      margin: 0;
    }

    &:hover {
      filter: brightness(0.9);
    }
  }

  @media (max-width: 640px) {
    > button {
      right: 50px;
    }
  }

  @media (max-width: 540px) {
    > button {
      font-size: 1.25rem;
      padding: 4px 16px;
      right: 30px;
    }
  }

  @media (max-width: 470px) {
    > button {
      font-size: 1.25rem;
      padding: 4px 8px;
      border-radius: 2px;
      top: 25px;

      p {
        display: none;
      }

      svg {
        display: flex;
      }
    }
  }

  @media (max-width: 350px) {
    > button {
      right: 10px;
    }
  }
`;

export const Row = styled.div`
  h2 {
    margin-left: 90px;
    margin-top: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    font-size: 1.75rem;
  }

  > div {
    padding: 0 15px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    justify-items: center;
    align-items: center;

    > h1 {
      margin-top: 1rem;
      grid-column-start: 1;
      grid-column-end: 5;
      align-items: center;
    }
  }

  > span {
    display: flex;
    align-items: center;
  }

  @media (max-width: 1470px) {
    > div {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: 1110px) {
    > div {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 750px) {
    > div {
      padding: 0;
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 415px) {
    h2 {
      margin-left: 35px;
      font-size: 1.5rem;
    }
  }

  @media (max-width: 330px) {
    h2 {
      margin-left: 12px;
    }
  }
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-left: 12px;

  background: #dcdcdc;

  border: 2px solid ${({ theme }) => theme.icon};
  border-radius: 2px;

  padding: 0 6px;

  input {
    padding: 0 6px 0 10px;
    font-size: 1.25rem;
    line-height: 26px;
    background: #dcdcdc;
    color: ${({ theme }) => theme.black};
  }

  svg {
    color: ${({ theme }) => theme.black};
  }

  @media (max-width: 330px) {
    input {
      width: 120px;
    }
  }
`;
